/**
 * brand.js — Configuración de marca del frontend.
 * 
 * Valores por defecto que se muestran ANTES de que
 * la API /api/site-config/public/ responda.
 * 
 * En producción, el store Vuex `brand` sobrescribe estos
 * valores con los datos de SiteConfig (DB).
 */

const brand = {
  // Identidad
  storeName: process.env.VUE_APP_STORE_NAME || 'Good Bareto',
  storeSlogan: 'Tu tienda online',
  storeLogoUrl: '',        // Se llena desde la API
  storeLogoAltUrl: '',

  // Contacto (fallback si la API aún no respondió o no hay fila en BD)
  contactEmail: 'goodbaretoatencionalcliente@gmail.com',
  contactPhone: '+5492974210699',
  contactWhatsapp: '5492974210699',
  whatsappMessage: 'Hola, quisiera hacer una consulta',
  contactAddress: '',

  // Social
  socialInstagram: 'https://www.instagram.com/goodbareto/',
  socialFacebook: '',
  socialTiktok: '',
  socialYoutube: '',
  socialTwitter: '',

  // Branding
  primaryColor: '#2563eb',
  secondaryColor: '#1e40af',
  accentColor: '#f59e0b',

  // Comercial
  currency: 'ARS',
  currencySymbol: '$',
  paymentProvider: 'mercadopago',

  // Features
  enableAgeVerification: false,
  enableBlog: true,
  enableDesktopApp: false,
  enableGuestCheckout: true,

  // SEO
  lang: 'es',
  geoRegion: 'AR',

  // Developer
  developerName: 'Gonzalo V',
  developerUrl: '',
};

export default brand;
